module.exports = __webpack_public_path__ + "img/topic_title.fca460f8.png";